import * as React from 'react';
import { AuthData } from '../../context/auth';
import { PolicyData, withPolicyContext } from '../../context/policy';
import {
	StyledSectionContainer,
	StyledTitle,
	StyledTitleContainer,
} from '../common';
import HistoricalQuotesTable from '../HistoricalQuotesTable';

interface Props {
	authData: AuthData;
	policyData: PolicyData;
}

const InvoicesView = (props: Props) => {
	const { policyData } = props;

	const { quotes } = policyData;

	return (
		<>
			<StyledTitleContainer>
				<StyledTitle>Historical Quotes</StyledTitle>
			</StyledTitleContainer>
			<hr />
			<StyledSectionContainer>
				<HistoricalQuotesTable quotes={quotes} />
			</StyledSectionContainer>
		</>
	);
};

export default withPolicyContext<Props>(InvoicesView);
